import axios from 'axios';

const request = async (options) => {
  const response = await axios({ ...options, validateStatus: () => true });
  if (response.status >= 400) {
    const error = new Error(
      `AVS request failed with status ${response.status}`
    );
    error.response = response;
    throw error;
  }
  return response.data;
};

const getChecks = async (paymentProfileId) =>
  request({
    method: 'GET',
    url: `/factoring/payment_profiles/${paymentProfileId}/avs/`,
  });

const runCheck = async (paymentProfileId, overrides) => {
  if (overrides.account_number) {
    throw new Error('Manual account entry is not available for AVS.');
  }
  return request({
    method: 'POST',
    url: `/factoring/payment_profiles/${paymentProfileId}/avs/`,
    data: overrides,
  });
};

export default { getChecks, runCheck };
